module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.2c1a616f0dcb77b456d88da794bc149b.woff";